import gql from 'graphql-tag';

const GET_SUBMISSION_STATUS = gql`
  query getSubmissionStatus($submissionId: String!) {
    getSubmissionStatus(submissionId: $submissionId) {
      submissionId
      caseExternalId
      status
      caseStatus
      attemptCount
      deadLettered
      errorCode
      errorMessage
      processedAt
      createdAt
      updatedAt
    }
  }
`;

export default GET_SUBMISSION_STATUS;
